module.exports = {
  // 是否线上
  online: process.env.NODE_ENV !== 'development',

  // 接口url
  apiUrl: '/api', // 必须，如：'//api-dev.haojigeyi.cn'
};
